import {ajaxGet} from "../shared/ajax";

const initDownloadButton = () => {

    const state = {
        link: null,
        isBlank: false,
        selected: null,
    };

    const downloadButton = document.querySelector('.download-button');

    const selected = document.querySelector('.download-selected');

    const elements = document.querySelectorAll('.download-item');

    const setLink = (link) =>  state.link = link;
    const setIsBlank = (isBlank) =>  state.isBlank = isBlank;
    const updateSelected = () => selected.textContent = `In ${state.selected}p`;

    const setSelected = (selected) => {
        state.selected = selected;
        updateSelected()
    }

    elements.forEach(element => {

        if (element.dataset.selected) {
            setLink(element.dataset.link);
            setSelected(element.dataset.res);
            setIsBlank(element.dataset.isBlank === '1');
        }

        element.addEventListener('click', (e) => {
            setLink(e.target.dataset.link);
            setSelected(e.target.dataset.res);
            setIsBlank(e.target.dataset.isBlank === '1');
        })
    });

    downloadButton.addEventListener('click', (e) => {
        if (state.link !== null) {
            if(state.isBlank) {
                window.open(state.link, "_blank");
            }
            else {
               ajaxGet({url: state.link})
            }
        }
    });

}

export default initDownloadButton;